import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-mroomsocial',
  templateUrl: './mroomsocial.component.html',
  styleUrls: ['./mroomsocial.component.css'],
})
export class MroomsocialComponent {
  url: string = 'socialContentRequests';
  data: Array<any> = [];
  searchText = '';
  filteredData: Array<any> = [];
  searchSuggestions: string[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 50;

  modalTitle: string = '';
  modalContent: string | null = null;
  private scrollPosition = 0;

  // Filters
  filters = {
    status: '',
    purpose: '',
    vertical: '',
    requested_by_type: '',
    platform: 'instagram',
  };

  platforms = [
    {
      value: 'instagram',
      label: 'Instagram',
      icon: 'fab fa-instagram',
      class: 'ig',
    },
    {
      value: 'facebook',
      label: 'Facebook',
      icon: 'fab fa-facebook-f',
      class: 'fb',
    },
    { value: 'youtube', label: 'YouTube', icon: 'fab fa-youtube', class: 'yt' },
    { value: 'tiktok', label: 'TikTok', icon: 'fab fa-tiktok', class: 'tt' },
  ];

  get selectedPlatformInfo() {
    return (
      this.platforms.find((p) => p.value === this.filters.platform) ||
      this.platforms[0]
    );
  }

  loading: boolean = true;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
  ];

  // ── 1. REQUEST INTAKE ──────────────────────────────────────────────────────
  intakeMetadata = {
    constitutingEntity: 'INITIATOR',
    handoffType: 'Weekly Block Cohort',
  };

  requestIntakeData = [
    {
      order_id: 'FB-FD-R1-0003241',
      platform: 'facebook',
      surface: 'Feed',
      category: 'Legal Courier Services',
      objective: 'Strategic Growth Mix',
      semantika_status: 'Instructed',
      semantika_icon: 'fas fa-check-circle',
      intake_status: 'Completed',
    },
    {
      order_id: 'FB-RL-R1-0003242',
      platform: 'facebook',
      surface: 'Reel',
      category: 'Task Runner Services',
      objective: 'Strategic Growth Mix',
      semantika_status: 'Processing',
      semantika_icon: 'fas fa-circle-notch',
      intake_status: 'Processing',
    },
    {
      order_id: 'FB-ST-R1-0003243',
      platform: 'facebook',
      surface: 'Story',
      category: 'Same-Day Courier',
      objective: 'Strategic Growth Mix',
      semantika_status: 'Pending',
      semantika_icon: 'fas fa-clock',
      intake_status: 'Held',
    },
    {
      order_id: 'IG-RL-R1-0003244',
      platform: 'instagram',
      surface: 'Reel',
      category: 'Luxury Concierge Services',
      objective: 'Strategic Growth Mix',
      semantika_status: 'Pending',
      semantika_icon: 'fas fa-clock',
      intake_status: 'Pending',
    },
    {
      order_id: 'IG-ST-R1-0003245',
      platform: 'instagram',
      surface: 'Story',
      category: 'Legal Courier Services',
      objective: 'Strategic Growth Mix',
      semantika_status: 'Pending',
      semantika_icon: 'fas fa-clock',
      intake_status: 'Pending',
    },
    {
      order_id: 'IG-CR-R1-0003246',
      platform: 'instagram',
      surface: 'Carousel',
      category: 'Same-Day Courier',
      objective: 'Strategic Growth Mix',
      semantika_status: 'Pending',
      semantika_icon: 'fas fa-clock',
      intake_status: 'Pending',
    },
    {
      order_id: null,
      platform: 'youtube',
      surface: 'Short',
      category: 'Long Distance Courier Services',
      objective: 'Strategic Growth Mix',
      semantika_status: null,
      semantika_icon: null,
      intake_status: 'Exception',
    },
    {
      order_id: 'TK-VD-R1-0003248',
      platform: 'tiktok',
      surface: 'Video',
      category: 'Hire Me by the Hour',
      objective: 'Strategic Growth Mix',
      semantika_status: 'Pending',
      semantika_icon: 'fas fa-clock',
      intake_status: 'Pending',
    },
  ];

  getSemantikaClass(status: string | null): string {
    const map: Record<string, string> = {
      Instructed: 'semantika-instructed',
      Processing: 'semantika-processing',
      Pending: 'semantika-pending',
    };
    return status ? map[status] || '' : '';
  }

  getIntakeStatusClass(status: string): string {
    const map: Record<string, string> = {
      Completed: 'intake-completed',
      Processing: 'intake-processing',
      Held: 'intake-held',
      Pending: 'intake-pending',
      Exception: 'intake-exception',
    };
    return map[status] || '';
  }

  // ── 2. PRODUCTION ──────────────────────────────────────────────────────────
  productionMetadata = {
    subtitle: 'Real-time progress by Order across all production stages',
    footerNote:
      'Note: Each Order advances independently through the stages. A completed Order remains in place until the Weekly Block is ready to move forward.',
  };

  productionData = [
    {
      order_id: 'FB-FD-R1-0003241',
      platform: 'facebook',
      surface: 'Feed',
      script_image: 'Finished',
      video_prod: 'N/A',
      status: 'Completed',
    },
    {
      order_id: 'FB-RL-R1-0003242',
      platform: 'facebook',
      surface: 'Reel',
      script_image: 'N/A',
      video_prod: 'Finished',
      status: 'Completed',
    },
    {
      order_id: 'FB-ST-R1-0003243',
      platform: 'facebook',
      surface: 'Story',
      script_image: 'Finished',
      video_prod: 'N/A',
      status: 'Completed',
    },
    {
      order_id: 'IG-RL-R1-0003244',
      platform: 'instagram',
      surface: 'Reel',
      script_image: 'N/A',
      video_prod: 'Processing',
      status: 'Processing',
    },
    {
      order_id: 'IG-ST-R1-0003245',
      platform: 'instagram',
      surface: 'Story',
      script_image: 'Finished',
      video_prod: 'N/A',
      status: 'Completed',
    },
    {
      order_id: 'IG-CR-R1-0003246',
      platform: 'instagram',
      surface: 'Carousel',
      script_image: 'Finished',
      video_prod: 'N/A',
      status: 'Completed',
    },
    {
      order_id: 'YT-SH-R1-0003247',
      platform: 'youtube',
      surface: 'Short',
      script_image: 'N/A',
      video_prod: 'Finished',
      status: 'Completed',
    },
    {
      order_id: 'TK-VD-R1-0003248',
      platform: 'tiktok',
      surface: 'Video',
      script_image: 'N/A',
      video_prod: 'Finished',
      status: 'Held',
    },
  ];

  getProductionBadgeClass(status: string): string {
    const map: Record<string, string> = {
      Finished: 'prod-badge-finished',
      Completed: 'prod-badge-finished',
      Processing: 'prod-badge-processing',
      Held: 'prod-badge-held',
    };
    return map[status] || '';
  }

  getProductionBadgeIcon(status: string): string {
    const map: Record<string, string> = {
      Finished: 'fas fa-check',
      Completed: 'fas fa-check',
      Processing: 'fas fa-circle-notch fa-spin',
    };
    return map[status] || '';
  }

  // ── 3. READY ───────────────────────────────────────────────────────────────
  readyMetadata = {
    subtitle: 'Publication-Ready Pieces Awaiting Execution',
  };

  readyPiecesData = [
    {
      order_id: 'FB-FD-R1-0003241',
      platform: 'facebook',
      surface: 'Feed',
      thumbnail: 'assets/img/pieces/delivery.png',
      ai_pass: 'Pass',
      posting_date: 'Tue, May 20, 2025',
      posting_time: '09:00 AM EDT',
      status: 'Held',
    },
    {
      order_id: 'FB-RL-R1-0003242',
      platform: 'facebook',
      surface: 'Reel',
      thumbnail: 'assets/img/pieces/van.png',
      ai_pass: 'Pass',
      posting_date: 'Wed, May 21, 2025',
      posting_time: '11:00 AM EDT',
      status: 'Posted',
    },
    {
      order_id: 'FB-ST-R1-0003243',
      platform: 'facebook',
      surface: 'Story',
      thumbnail: '',
      ai_pass: 'Failed',
      posting_date: 'Thu, May 22, 2025',
      posting_time: '01:00 PM EDT',
      status: 'Reject',
    },
    {
      order_id: 'IG-RL-R1-0003244',
      platform: 'instagram',
      surface: 'Reel',
      thumbnail: 'assets/img/pieces/logistica.png',
      ai_pass: 'Pass',
      posting_date: 'Fri, May 23, 2025',
      posting_time: '02:00 PM EDT',
      status: 'Retry',
    },
    {
      order_id: 'IG-ST-R1-0003245',
      platform: 'instagram',
      surface: 'Story',
      thumbnail: 'assets/img/pieces/reunion.png',
      ai_pass: 'Pass',
      posting_date: 'Sat, May 24, 2025',
      posting_time: '03:00 PM EDT',
      status: 'Scheduled',
    },
    {
      order_id: 'IG-CR-R1-0003246',
      platform: 'instagram',
      surface: 'Carousel',
      thumbnail: 'assets/img/pieces/logistica.png',
      ai_pass: 'Pass',
      posting_date: 'Sun, May 25, 2025',
      posting_time: '04:00 PM EDT',
      status: 'Scheduled',
    },
    {
      order_id: 'YT-SH-R1-0003247',
      platform: 'youtube',
      surface: 'Short',
      thumbnail: 'assets/img/pieces/delivery.png',
      ai_pass: 'Pending',
      posting_date: 'Mon, May 19, 2025',
      posting_time: '05:00 PM EDT',
      status: 'Scheduled',
    },
    {
      order_id: 'TK-VD-R1-0003248',
      platform: 'tiktok',
      surface: 'Video',
      thumbnail: 'assets/img/pieces/van.png',
      ai_pass: 'Pass',
      posting_date: 'Tue, May 20, 2025',
      posting_time: '06:00 PM EDT',
      status: 'Scheduled',
    },
  ];

  getAiPassClass(pass: string): string {
    const map: Record<string, string> = {
      Pass: 'aipass-pass',
      Failed: 'aipass-failed',
      Pending: 'aipass-pending',
    };
    return map[pass] || '';
  }

  getReadyStatusClass(status: string): string {
    const map: Record<string, string> = {
      Held: 'ready-held',
      Posted: 'ready-posted',
      Reject: 'ready-reject',
      Retry: 'ready-retry',
      Scheduled: 'ready-scheduled',
    };
    return map[status] || '';
  }

  // ── 4. ISSUES ───────────────────────────────────────────────────────────────
  issuesMetadata = {
    title: '4. ISSUES',
    subtitle: 'Operational Issue Record',
    selectedDate: 'August 2026',
  };

  issuesStats = {
    total: { value: 60, percent: 100 },
    reject: { value: 18, percent: 30.0 },
    held: { value: 12, percent: 20.0 },
    expired: { value: 30, percent: 50.0 },
    mostAffected: { platform: 'Instagram Reel', count: 20, percent: 33.3 },
  };

  issuesData = [
    {
      order_id: 'IG-RL-R1-0000123',
      platform: 'instagram',
      surface: 'Reel',
      issue: 'Expired',
    },
    {
      order_id: 'TK-VD-R1-0000987',
      platform: 'tiktok',
      surface: 'Video',
      issue: 'Expired',
    },
    {
      order_id: 'FB-FD-R1-0000456',
      platform: 'facebook',
      surface: 'Feed',
      issue: 'Reject',
    },
    {
      order_id: 'IG-ST-R1-0000321',
      platform: 'instagram',
      surface: 'Story',
      issue: 'Held',
    },
    {
      order_id: 'YT-SH-R1-0000654',
      platform: 'youtube',
      surface: 'Short',
      issue: 'Reject',
    },
    {
      order_id: 'IG-RL-R1-0000789',
      platform: 'instagram',
      surface: 'Reel',
      issue: 'Expired',
    },
    {
      order_id: 'IG-CR-R1-0000159',
      platform: 'instagram',
      surface: 'Carousel',
      issue: 'Held',
    },
    {
      order_id: 'TK-VD-R1-0000753',
      platform: 'tiktok',
      surface: 'Video',
      issue: 'Expired',
    },
  ];

  getIssueTypeBadgeClass(issue: string): string {
    const map: Record<string, string> = {
      Expired: 'issue-expired',
      Reject: 'issue-reject',
      Held: 'issue-held',
    };
    return map[issue] || '';
  }

  getIssueTypeIcon(issue: string): string {
    const map: Record<string, string> = {
      Expired: 'far fa-clock',
      Reject: 'fas fa-times',
      Held: 'fas fa-pause',
    };
    return map[issue] || '';
  }

  // ── ISSUE MODAL STATE ──────────────────────────────────────────────────────
  isIssueModalOpen = false;
  selectedIssueDetails: any = null;

  openIssueModal(issueRow: any) {
    this.selectedIssueDetails = {
      platform: issueRow.platform,
      platformLabel:
        issueRow.platform.charAt(0).toUpperCase() + issueRow.platform.slice(1),
      surface: issueRow.surface,
      issueType: issueRow.issue,
      orderId: issueRow.order_id,
      category: 'Product Launch', // Mock data as per UI
      objective: 'Awareness', // Mock data as per UI
      concurrentCondition: 'Held', // Mock data as per UI
      postingDate: 'Sep 02, 2025',
      postingTime: '10:00 AM',
      conclusionTitle: 'AI PASS FAILURE CONCLUSION',
      conclusionDetails: [
        'The Piece failed Category Alignment and Visual-Content Relevance.',
        'The governed Category requires communication of an immediate long-distance courier service, but the narrative and primary visual depict carpentry work.',
        'The visual and narrative therefore materially contradict the governed content context and the Piece was not eligible for publication.',
        'No publishing attempt occurred.',
      ],
      summaryTitle: 'OPERATIONAL SUMMARY',
      summaryDetails: [
        'AI Pass returned Failed before publication.',
        'READY resolved the Order as Reject.',
        'No publishing attempt occurred.',
        '',
        'The Order was also under an active Hold when AI Pass returned Failed.',
        'The Hold remains preserved as concurrent operational history.',
      ],
    };
    this.isIssueModalOpen = true;
    this.lockPageScroll();
  }

  closeIssueModal() {
    this.isIssueModalOpen = false;
    this.selectedIssueDetails = null;
    this.unlockPageScroll();
  }

  // ── 3.2 POSTING SCHEDULE MODAL ─────────────────────────────────────────────
  isScheduleModalOpen = false;

  recentHistoryData = [
    {
      order_id: 'FB-FD-R1-0003241',
      platform: 'facebook',
      platformLabel: 'Facebook',
      surface: 'Feed',
      date: 'Tue, Apr 15, 2025',
      time: '09:00 AM EDT',
      outcome: 'Posted',
    },
    {
      order_id: 'FB-RL-R1-0003242',
      platform: 'facebook',
      platformLabel: 'Facebook',
      surface: 'Reel',
      date: 'Wed, Apr 16, 2025',
      time: '11:00 AM EDT',
      outcome: 'Held',
    },
    {
      order_id: 'FB-ST-R1-0003243',
      platform: 'facebook',
      platformLabel: 'Facebook',
      surface: 'Story',
      date: 'Thu, Apr 17, 2025',
      time: '01:00 PM EDT',
      outcome: 'Reject',
    },
    {
      order_id: 'IG-RL-R1-0003244',
      platform: 'instagram',
      platformLabel: 'Instagram',
      surface: 'Reel',
      date: 'Fri, Apr 18, 2025',
      time: '02:00 PM EDT',
      outcome: 'Retry',
    },
    {
      order_id: 'IG-ST-R1-0003245',
      platform: 'instagram',
      platformLabel: 'Instagram',
      surface: 'Story',
      date: 'Sat, Apr 19, 2025',
      time: '03:00 PM EDT',
      outcome: 'Posted',
    },
    {
      order_id: 'IG-CR-R1-0003246',
      platform: 'instagram',
      platformLabel: 'Instagram',
      surface: 'Carousel',
      date: 'Sun, Apr 20, 2025',
      time: '04:00 PM EDT',
      outcome: 'Posted',
    },
    {
      order_id: 'YT-SH-R1-0003247',
      platform: 'youtube',
      platformLabel: 'YouTube',
      surface: 'Short',
      date: 'Mon, Apr 14, 2025',
      time: '05:00 PM EDT',
      outcome: 'Posted',
    },
    {
      order_id: 'TK-VD-R1-0003248',
      platform: 'tiktok',
      platformLabel: 'TikTok',
      surface: 'Video',
      date: 'Tue, Apr 15, 2025',
      time: '06:00 PM EDT',
      outcome: 'Retry',
    },
  ];

  upcomingScheduleData = [
    {
      platform: 'facebook',
      platformLabel: 'Facebook',
      surface: 'Feed',
      date: 'Tue, May 6, 2025',
      time: '09:00 AM EDT',
      status: 'Scheduled',
    },
    {
      platform: 'facebook',
      platformLabel: 'Facebook',
      surface: 'Reel',
      date: 'Wed, May 7, 2025',
      time: '11:00 AM EDT',
      status: 'Scheduled',
    },
    {
      platform: 'facebook',
      platformLabel: 'Facebook',
      surface: 'Story',
      date: 'Thu, May 8, 2025',
      time: '01:00 PM EDT',
      status: 'Scheduled',
    },
    {
      platform: 'instagram',
      platformLabel: 'Instagram',
      surface: 'Reel',
      date: 'Fri, May 9, 2025',
      time: '02:00 PM EDT',
      status: 'Scheduled',
    },
    {
      platform: 'instagram',
      platformLabel: 'Instagram',
      surface: 'Story',
      date: 'Sat, May 10, 2025',
      time: '03:00 PM EDT',
      status: 'Scheduled',
    },
    {
      platform: 'instagram',
      platformLabel: 'Instagram',
      surface: 'Carousel',
      date: 'Sun, May 11, 2025',
      time: '04:00 PM EDT',
      status: 'Scheduled',
    },
    {
      platform: 'youtube',
      platformLabel: 'YouTube',
      surface: 'Short',
      date: 'Mon, May 12, 2025',
      time: '05:00 PM EDT',
      status: 'Scheduled',
    },
    {
      platform: 'tiktok',
      platformLabel: 'TikTok',
      surface: 'Video',
      date: 'Tue, May 13, 2025',
      time: '06:00 PM EDT',
      status: 'Scheduled',
    },
  ];

  openScheduleModal() {
    this.isScheduleModalOpen = true;
    this.lockPageScroll();
  }

  closeScheduleModal() {
    this.isScheduleModalOpen = false;
    this.unlockPageScroll();
  }

  getOutcomeBadgeClass(outcome: string): string {
    const map: Record<string, string> = {
      Posted: 'sched-badge-posted',
      Held: 'sched-badge-held',
      Reject: 'sched-badge-reject',
      Retry: 'sched-badge-retry',
      Scheduled: 'sched-badge-scheduled',
    };
    return map[outcome] || '';
  }

  // ── 5. PAUSE ───────────────────────────────────────────────────────────────

  pauseMetadata = {
    title: '5. PAUSE',
    subtitle: 'Control publishing availability by Platform and Surface',
    globalStatus: 'Publishing Active with Exceptions',
    lastUpdated: 'Last updated: Aug 21, 2026 · 10:24 AM',
  };

  pauseData = [
    {
      platform: 'facebook',
      platformLabel: 'Facebook',
      surfaceCount: 3,
      surfaces: [
        { name: 'Feed', status: 'Active' },
        { name: 'Reel', status: 'Active' },
        { name: 'Story', status: 'Active' },
      ],
    },
    {
      platform: 'instagram',
      platformLabel: 'Instagram',
      surfaceCount: 3,
      surfaces: [
        { name: 'Reel', status: 'Held' },
        { name: 'Story', status: 'Active' },
        { name: 'Carousel', status: 'Active' },
      ],
    },
    {
      platform: 'youtube',
      platformLabel: 'YouTube',
      surfaceCount: 1,
      surfaces: [{ name: 'Short', status: 'Active' }],
    },
    {
      platform: 'tiktok',
      platformLabel: 'TikTok',
      surfaceCount: 1,
      surfaces: [{ name: 'Video', status: 'Active' }],
    },
  ];

  getPauseStatusClass(status: string): string {
    const map: Record<string, string> = {
      Active: 'pause-status-active',
      Held: 'pause-status-held',
    };
    return map[status] || '';
  }

  getPauseStatusIcon(status: string): string {
    const map: Record<string, string> = {
      Active: 'fas fa-circle',
      Held: 'fas fa-pause-circle',
    };
    return map[status] || '';
  }

  // ── PAUSE MODAL STATE ───────────────────────────────────────────────────────
  isPauseModalOpen = false;
  pauseModalPlatform = '';
  pauseModalSurface = '';
  pauseBehavior: 'immediate' | 'drain' = 'immediate';
  pauseReason = '';

  openPauseModal(platformLabel: string, surfaceName: string) {
    this.pauseModalPlatform = platformLabel;
    this.pauseModalSurface = surfaceName;
    this.pauseBehavior = 'immediate';
    this.pauseReason = '';
    this.isPauseModalOpen = true;
    this.lockPageScroll();
  }

  closePauseModal() {
    this.isPauseModalOpen = false;
    this.unlockPageScroll();
  }

  // private updateBodyScroll() {
  //   document.body.classList.toggle(
  //     'modal-open-custom',
  //     this.isIssueModalOpen || this.isPauseModalOpen,
  //   );
  // }

  private lockPageScroll() {
    this.scrollPosition = window.scrollY;

    document.documentElement.style.overflow = 'hidden';

    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  private unlockPageScroll() {
    document.documentElement.style.overflow = '';

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';

    window.scrollTo(0, this.scrollPosition);
  }

  confirmPause() {
    // Find the surface and mark it as Held
    const platform = this.pauseData.find(
      (p) => p.platformLabel === this.pauseModalPlatform,
    );
    if (platform) {
      const surface = platform.surfaces.find(
        (s) => s.name === this.pauseModalSurface,
      );
      if (surface) surface.status = 'Held';
    }
    console.log('Pause confirmed:', {
      platform: this.pauseModalPlatform,
      surface: this.pauseModalSurface,
      behavior: this.pauseBehavior,
      reason: this.pauseReason,
    });
    this.closePauseModal();
  }

  resumeSurface(platformLabel: string, surfaceName: string) {
    const platform = this.pauseData.find(
      (p) => p.platformLabel === platformLabel,
    );
    if (platform) {
      const surface = platform.surfaces.find((s) => s.name === surfaceName);
      if (surface) surface.status = 'Active';
    }
  }

  // ── 6. ADS ─────────────────────────────────────────────────────────────────
  adsMetadata = {
    title: '6. ADS',
    subtitle: 'Activate Paid Distribution by Platform and Surface',
  };

  adsData = [
    {
      platform: 'facebook',
      platformLabel: 'Facebook',
      surface: 'Feed',
      active: false,
    },
    {
      platform: 'facebook',
      platformLabel: 'Facebook',
      surface: 'Reel',
      active: false,
    },
    {
      platform: 'facebook',
      platformLabel: 'Facebook',
      surface: 'Story',
      active: false,
    },
    {
      platform: 'instagram',
      platformLabel: 'Instagram',
      surface: 'Reel',
      active: false,
    },
    {
      platform: 'instagram',
      platformLabel: 'Instagram',
      surface: 'Story',
      active: false,
    },
    {
      platform: 'instagram',
      platformLabel: 'Instagram',
      surface: 'Carousel',
      active: false,
    },
    {
      platform: 'youtube',
      platformLabel: 'YouTube',
      surface: 'Short',
      active: false,
    },
    {
      platform: 'tiktok',
      platformLabel: 'TikTok',
      surface: 'Video',
      active: false,
    },
  ];

  getSurfaceBadgeClass(surface: string): string {
    const map: Record<string, string> = {
      Feed: 'ads-badge-feed',
      Reel: 'ads-badge-reel',
      Story: 'ads-badge-story',
      Carousel: 'ads-badge-carousel',
      Short: 'ads-badge-short',
      Video: 'ads-badge-video',
    };
    return map[surface] || 'ads-badge-default';
  }

  surfacesReviewedData = [
    {
      id: 1,
      surfaceName: 'Feed Posts',
      surfaceIcon: 'fas fa-image text-primary me-2 bg-light p-1 rounded',
      surfaceIconStyle: '',
      description: 'Organic posts in the main feed',
      outcomeText: 'Conclusion Available',
      outcomeIcon: 'far fa-check-circle text-success me-1',
      outcomeClass: '',
      evidenceLevel: 'High',
      evidenceClass: '',
      evidenceDots: ['text-success', 'text-success', 'text-success'],
      notes: 'Sufficient and consistent evidence',
      lastRow: false,
    },
    {
      id: 2,
      surfaceName: 'Reels',
      surfaceIcon: 'fas fa-mobile-alt me-2',
      surfaceIconStyle: 'color: #6f42c1',
      description: 'Short-form vertical videos',
      outcomeText: 'Conclusion Available',
      outcomeIcon: 'far fa-check-circle text-success me-1',
      outcomeClass: '',
      evidenceLevel: 'High',
      evidenceClass: '',
      evidenceDots: ['text-success', 'text-success', 'text-success'],
      notes: 'Sufficient and consistent evidence',
      lastRow: false,
    },
    {
      id: 3,
      surfaceName: 'Stories',
      surfaceIcon: 'far fa-circle text-danger me-2',
      surfaceIconStyle: '',
      description: '24-hour ephemeral content',
      outcomeText: 'Insufficient Evidence',
      outcomeIcon: 'fas fa-pause-circle text-warning me-1',
      outcomeClass: '',
      evidenceLevel: 'Low',
      evidenceClass: '',
      evidenceDots: ['text-warning', 'text-warning', 'text-light'],
      notes: 'Limited data during period',
      lastRow: false,
    },
    {
      id: 4,
      surfaceName: 'Carousels',
      surfaceIcon: 'far fa-images text-info me-2',
      surfaceIconStyle: '',
      description: 'Multi-image/video posts',
      outcomeText: 'No Material Finding',
      outcomeIcon: 'fas fa-minus-circle text-primary me-1',
      outcomeClass: '',
      evidenceLevel: 'Medium',
      evidenceClass: '',
      evidenceDots: ['text-primary', 'text-light', 'text-light'],
      notes: 'No significant changes observed',
      lastRow: false,
    },
    {
      id: 5,
      surfaceName: 'Live',
      surfaceIcon: 'fas fa-rss text-danger me-2',
      surfaceIconStyle: '',
      description: 'Instagram Live sessions',
      outcomeText: 'No Activity Observed',
      outcomeIcon: 'fas fa-minus-circle text-secondary me-1',
      outcomeClass: 'text-muted',
      evidenceLevel: 'N/A',
      evidenceClass: 'text-muted',
      evidenceDots: ['text-muted', 'text-muted', 'text-muted'],
      notes: 'No live sessions detected',
      lastRow: true,
    },
  ];

  competitorsData = [
    {
      id: 1,
      name: 'Court Express NYC',
      city: 'New York',
      website: 'courtexpressnyc.com',
      websiteUrl: '#',
      categories: 'Legal Courier, Court Filings, Litigation Support',
      surfaces: 'Feed Posts, Reels, Stories, Carousels',
      lastRow: false,
    },
    {
      id: 2,
      name: 'Legal Couriers Miami',
      city: 'Miami',
      website: 'legalcouriersmiami.com',
      websiteUrl: '#',
      categories: 'Legal Courier, Process Serving, Same-Day Courier',
      surfaces: 'Feed Posts, Reels, Stories',
      lastRow: false,
    },
    {
      id: 3,
      name: 'Swift Legal Delivery',
      city: 'London',
      website: 'swiftlegaldelivery.co.uk',
      websiteUrl: '#',
      categories: 'Court Filings, Legal Courier, Litigation Support',
      surfaces: 'Feed Posts, Reels, Stories, Carousels',
      lastRow: false,
    },
    {
      id: 4,
      name: 'LA Legal Runners',
      city: 'Los Angeles',
      website: 'lalegalrunners.com',
      websiteUrl: '#',
      categories: 'Legal Courier, Same-Day Courier, Process Serving',
      surfaces: 'Feed Posts, Stories, Carousels',
      lastRow: false,
    },
    {
      id: 5,
      name: 'Prime Same-Day Courier',
      city: 'Chicago',
      website: 'primesamedaycourier.com',
      websiteUrl: '#',
      categories: 'Same-Day Courier, Court Filings, Legal Support',
      surfaces: 'Feed Posts, Reels, Stories',
      lastRow: true,
    },
  ];

  viewMode: string = 'all';

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.loading = true;
    let queryParams = `?page=${this.currentPage}&limit=${this.itemsPerPage}&search=${this.searchText}`;

    if (this.filters.status) queryParams += `&status=${this.filters.status}`;
    if (this.filters.purpose) queryParams += `&purpose=${this.filters.purpose}`;
    if (this.filters.vertical)
      queryParams += `&vertical=${this.filters.vertical}`;
    if (this.filters.requested_by_type)
      queryParams += `&requested_by_type=${this.filters.requested_by_type}`;
    if (this.filters.platform)
      queryParams += `&platform=${this.filters.platform}`;

    this.dataService
      .getData(`${this.url}${queryParams}`)
      .subscribe((response) => {
        if (response && response.data) {
          this.data = response.data;
          this.filteredData = [...this.data];
          this.updateSuggestions();
        }
        this.loading = false;
      });
  }

  applyFilters(): void {
    this.currentPage = 1;
    this.getData();
  }

  resetFilters(): void {
    this.filters = {
      status: '',
      purpose: '',
      vertical: '',
      requested_by_type: '',
      platform: 'instagram',
    };
    this.applyFilters();
  }

  updateItemStatus(id: string, status: string): void {
    this.dataService
      .putData(`${this.url}/${id}/status`, { status })
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar el registro?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  generateAssets(id: string): void {
    if (!confirm('¿Desea generar los assets para este requerimiento?')) return;

    this.dataService
      .postData(`${this.url}/${id}/generate-assets`, {})
      .subscribe((response) => {
        console.log('response', response);
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  filter() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          (item.request_id && item.request_id.toLowerCase().includes(texto)) ||
          (item.notes && item.notes.toLowerCase().includes(texto))
        );
      });
    }
  }

  updateSuggestions() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.request_id) sugerenciasSet.add(item.request_id);
    });
    this.searchSuggestions = Array.from(sugerenciasSet).filter(Boolean);
  }

  showModal(title: string, content: string) {
    this.modalTitle = title;
    this.modalContent = content;
  }

  closeModal() {
    this.modalContent = null;
  }

  switchView(mode: string): void {
    this.viewMode = mode;
    this.currentPage = 1;
    this.getData();
  }

  getPlatformIcon(platform: string): string {
    const map: Record<string, string> = {
      instagram: 'fab fa-instagram',
      facebook: 'fab fa-facebook-f',
      youtube: 'fab fa-youtube',
      tiktok: 'fab fa-tiktok',
    };
    return map[(platform || '').toLowerCase()] || 'fas fa-globe';
  }

  getPlatformColor(platform: string): string {
    const map: Record<string, string> = {
      instagram: '#e1306c',
      facebook: '#1877f2',
      youtube: '#ff0000',
      tiktok: '#000000',
    };
    return map[(platform || '').toLowerCase()] || '#6c757d';
  }

  getPlatformClass(platform: string): string {
    const map: Record<string, string> = {
      instagram: 'ig',
      facebook: 'fb',
      youtube: 'yt',
      tiktok: 'tt',
    };
    return map[(platform || '').toLowerCase()] || '';
  }
}
